import { render } from "./Intro.vue?vue&type=template&id=105e1fc0&scoped=true"
import script from "./Intro.vue?vue&type=script&lang=js"
export * from "./Intro.vue?vue&type=script&lang=js"

import "@/assets/css/topicContent.sass?vue&type=style&index=0&id=105e1fc0&lang=sass&scoped=true"
import "./Intro.vue?vue&type=style&index=1&id=105e1fc0&lang=sass&scoped=true"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-105e1fc0"]])

export default __exports__